module.exports = __webpack_public_path__ + "static/media/buy_express.13f89a58.jpg";